import { FormCheck, Row } from "react-bootstrap";
import { useReferralFormData, useTIFFormData } from "../../../../hooks";
import { displayDate, getValueOrBlank, displayTime } from "../../../../helper-functions";
import { AutoCol } from "../../../../component-library";
import { TissueInformationFormProps } from ".";

export function TIFDonorInfoShort({ tissueId }: Readonly<TissueInformationFormProps>) {
    const {
        _case,
        donor,
        tissue,
        latestStorageSolution,
        latestLotNumber,
        latestExpDate,
        recoveryData,
        dToPDisplayValue,
        procuredByUserName,
    } = useTIFFormData({ tissueId });

    const { donorAge, donorGender, donorRace, donorTimeOfDeathDateAndTime } = useReferralFormData(_case?.referral);

    return (
        <>
            <Row>
                <AutoCol>Donor #: {getValueOrBlank(donor?.number)}</AutoCol>
                <AutoCol className="fw-bold">
                    Cause of Death: {getValueOrBlank(recoveryData?.PrimaryCauseOfDeath)}
                </AutoCol>
                <AutoCol>Secondary Cause of Death: {getValueOrBlank(recoveryData?.SecondaryCauseOfDeath)}</AutoCol>
            </Row>
            <Row>
                <AutoCol className="fw-bold">Age: {donorAge}</AutoCol>
                <AutoCol>Sex: {donorGender}</AutoCol>
                <AutoCol>Race: {donorRace}</AutoCol>
            </Row>
            <Row>
                <AutoCol className="fw-bold">Date/Time of Cardiac Death: {donorTimeOfDeathDateAndTime}</AutoCol>
                <AutoCol>
                    Date/Time of Ocular Cooling: {getValueOrBlank(displayDate(recoveryData?.OcularCoolingDate))}{" "}
                    {getValueOrBlank(displayTime(recoveryData?.OcularCoolingTime))}
                </AutoCol>
                {!!recoveryData?.ocularCoolingNA && (
                    <AutoCol>
                        <FormCheck disabled checked={recoveryData?.ocularCoolingNA} label="N/A" />
                    </AutoCol>
                )}
            </Row>
            <Row>
                <AutoCol className="fw-bold">
                    Date/Time of Procedure: {getValueOrBlank(displayDate(recoveryData?.ProcedureDate))}{" "}
                    {getValueOrBlank(displayTime(recoveryData?.ProcedureTime))}
                </AutoCol>
                <AutoCol>
                    Procedure:{" "}
                    {getValueOrBlank(
                        tissue?.side === "OD" ? recoveryData?.procedureTypeOD : recoveryData?.procedureTypeOS
                    )}
                </AutoCol>
                <AutoCol>Recovery Technician: {getValueOrBlank(procuredByUserName)}</AutoCol>
            </Row>
            <Row>
                <AutoCol className="fw-bold">Death to Preservation: {dToPDisplayValue}</AutoCol>
            </Row>
            <Row>
                <AutoCol>Storage Solution: {latestStorageSolution}</AutoCol>
                <AutoCol>Lot No.: {latestLotNumber}</AutoCol>
                <AutoCol>Exp. Date: {latestExpDate}</AutoCol>
            </Row>
        </>
    );
}
